import React, { useEffect, useState } from "react";
import CustomInput from "../Custom/CustomInput";
import { useNavigate } from "react-router-dom";
import CustomButton from "../Custom/CustomButton";
import axios from "axios";
import { useDispatch } from "react-redux";
import allActions from "../../Action/allActions";
import cookie from "js-cookie";

const SignIn = () => {
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    resetForm();
  }, []);

  const resetForm = () => {
    setFormData({
      email: "",
      password: "",
    });
    setError("");
  };

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setFormData({
      ...formData,
      [id]: value,
    });
    setError("");
  };

  const OnClickSignIn = async () => {
    if (!formData.email || !formData.password) {
      setError("Email and password required");
      return;
    }

    setSaveIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/login`,
        {
          email: formData.email.toLowerCase().trim(),
          password: formData.password,
        }
      );

      let data = response.data;
      
      // Handle BOM in response
      if (typeof data === 'string') {
        const jsonStart = data.indexOf('{');
        if (jsonStart > 0) {
          data = JSON.parse(data.substring(jsonStart));
        } else {
          data = JSON.parse(data);
        }
      }

      if (data.success) {
        // Store JWT token
        cookie.set("token", data.token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;

        // Dispatch user to Redux
        dispatch(allActions.userActions.setUser({
          id: data.user_id,
          username: data.username,
          email: data.email,
          name: data.name
        }));

        setSaveIsLoading(false);
        navigate("/ShoppingCart");
      } else {
        setError(data.error || "Login failed");
        setSaveIsLoading(false);
      }
    } catch (error) {
      console.log("Error:", error);
      if (error?.response?.status === 401) {
        setError("Invalid email or password");
      } else {
        setError(error.response?.data?.error || "Login failed");
      }
      setSaveIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    if (e.key === "Enter") {
      OnClickSignIn();
    }
  };

  return (
    <div>
      <div className="SignIn-div1">
        <p className="SignIn-Title">Existing customer</p>
      </div>
      <p className="SignIn-descp">
        Make purchases faster using previously saved details. Track previous
        orders and easily request returns from the website.
      </p>

      {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}

      <CustomInput
        placeholder={"Email"}
        onChange={handleInputChange}
        id={"email"}
        value={formData.email}
        onKeyDown={handleSubmit}
        type="email"
      />
      <CustomInput
        placeholder={"Password"}
        onChange={handleInputChange}
        id={"password"}
        value={formData.password}
        onKeyDown={handleSubmit}
        type="password"
      />

      <div style={{ marginTop: "20px" }}>
        <CustomButton
          button_text={saveIsLoading ? "Signing In..." : "Sign In"}
          onclick={OnClickSignIn}
          isDisabled={saveIsLoading}
        />
      </div>
    </div>
  );
};

export default SignIn;